/**
 * Google Mapの読み込み
 */
export default function() {
  const element = document.getElementById('js-googleMap');
  if(element) {
    // Map 設定
    const maplat = element.dataset.lat * 1;
    const maplang = element.dataset.long * 1;


    const setMapLatLng = {lat: maplat, lng: maplang};

    // console.log(setMapLatLng);
    const setMapStyle = [
      {
        "featureType": "all",
        "stylers": [
          { "saturation": -300 }
        ]
      }
    ];
    const setMapOption = {
      center: setMapLatLng,
      scrollwheel: false,
      zoom: 18,
      styles: setMapStyle
    };

    // mapのインスタンス生成
    const map = new google.maps.Map(element, setMapOption)

    // ブラウザ幅から、ピンのサイズを定義
    let sizeWidth;
    let sizeHeight;
    if(window.innerWidth < 768) { // SP size
      sizeWidth = 65;
      sizeHeight = 78;
    } else { // PC size
      sizeWidth = 79;
      sizeHeight = 94;
    }

    // marker 設定
    const setMarkerIcon = {
      // url: location.protocol + '//' + location.hostname + '/wp-content/themes/metricswork/assets/images/common/pin@2x.png',
      url: location.protocol + '//' + location.hostname + '/wp/wp-content/themes/metricswork/bundle/assets/images/common/pin@2x.png',
      sizeWidth: sizeWidth,
      sizeHeight: sizeHeight,
    }
    const setMarkerOption = {
      position: setMapLatLng,
      map: map,
      icon: {
        url: setMarkerIcon.url,
        scaledSize: new google.maps.Size(setMarkerIcon.sizeWidth, setMarkerIcon.sizeHeight)
      }
    }
    const marker = new google.maps.Marker(setMarkerOption);
  }
}